import type { ReactNode } from 'react';
import { Button } from './Primitives';

export interface EmptyStateProps {
  /** One line of plain text. No illustrations. */
  message: string;
  action?: ReactNode;
}

export function EmptyState({ message, action }: EmptyStateProps) {
  return (
    <div className="o-empty">
      <p>{message}</p>
      {action}
    </div>
  );
}

export interface ErrorStateProps {
  message: string;
  /** Last six characters of the request id, so a failure can be found in the log. */
  requestId?: string | null;
  onRetry?: () => void;
}

export function ErrorState({ message, requestId, onRetry }: ErrorStateProps) {
  return (
    <div className="o-error" role="alert">
      <p>{message}</p>
      {requestId ? <p className="o-error__detail">request {requestId}</p> : null}
      {onRetry ? (
        <Button variant="ghost" onClick={onRetry}>
          Retry
        </Button>
      ) : null}
    </div>
  );
}
